<template>
    <div>
        <div v-if="$root.user.date_of_birth" class="bottom-line p-4 flex justify-between items-center">
            <p>
                Date of birth
            </p>
            <p class="font-semibold">{{ $root.user.date_of_birth | date('MMMM Do, YYYY') }}</p>
        </div>
        <div v-if="$root.user.annual_income" class="bottom-line p-4 flex justify-between items-center">
            <p>
                Annual Income
            </p>
            <p class="font-semibold">{{ $root.user.annual_income | money(0) }}</p>
        </div>
        <div v-if="$root.user.monthly_income" class="bottom-line p-4 flex justify-between items-center">
            <p>
                Monthly Income
            </p>
            <p class="font-semibold">{{ $root.user.monthly_income | money(0) }}</p>
        </div>
        <div v-if="$root.user.income_source_pretty" class="bottom-line p-4 flex justify-between items-center">
            <p>
                Income Source
            </p>
            <p class="font-semibold">{{ $root.user.income_source_pretty }}</p>
        </div>
        <div v-if="$root.user.address" class="bottom-line p-4 flex justify-between items-center">
            <p class="mr-6">
                Address
            </p>
            <p class="font-semibold text-right" v-html="address" />
        </div>
        <div v-if="$root.user.phone_number" class="p-4 flex justify-between items-center">
            <p>
                Phone
            </p>
            <p class="font-semibold">{{ $root.user.phone_number | phone }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            /**
             * @returns {string}
             */
            address() {
                return [
                    [this.$root.user.address, this.$root.user.address2].join(' '),
                    [`${this.$root.user.city}, ${this.$root.user.state} ${this.$root.user.zip}`]
                ].join('<br />');
            }
        }
    }
</script>